A page of position profiles that belong to the opening.

A maximum of 50 position profiles can be returned in a single page.
Additional position profiles can be queried using a pagination cursor.

The result list is returned in ascending creation date & time order.
It starts from the earliest known position profile if no pagination arguments are provided.
